<template>
    <div v-if="motm != null" class="box opacity-07 motm">
        <div v-if="votingOpen" class="motm-badge motm-badge--live">
            <span class="motm-badge-dot"></span>
            Abstimmung läuft
        </div>
        <div v-else-if="motm.isFinal" class="motm-badge motm-badge--closed">
            Abstimmung beendet
        </div>

        <span class="h4 motm-title">Spieler des Spieltags</span>

        <div class="motm-list">
            <div v-for="(player, idx) in motm.top" :key="idx" class="motm-row" :class="{ 'motm-row--first': idx === 0 }">
                <div class="motm-fill" :style="{ width: player.percentage + '%' }"></div>
                <div class="motm-content">
                    <span class="motm-rank">{{ idx === 0 ? '🏆' : (idx + 1) + '.' }}</span>
                    <span class="motm-name">{{ player.displayName }}</span>
                    <span class="motm-votes">{{ player.voteCount }} 👍</span>
                    <b class="motm-pct">{{ player.percentage }}%</b>
                </div>
            </div>
        </div>

        <div v-if="votingOpen" class="mt-3">
            <a :href="discordVoteLink" target="_blank" rel="noopener" class="modern-btn">Zur Abstimmung</a>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3">
            <span><b>{{ motm.totalVotes }}</b> Stimmen</span>
            <span v-if="!motm.isFinal" class="motm-muted" :title="'Letztes Update: ' + lastUpdate">
                <font-awesome-icon icon="clock" /> {{ lastUpdate }}
            </span>
        </div>
    </div>
</template>

<script>
import * as utils from '../utils.js';

export default {
    props: {
        motm: {
            type: Object,
            default: null
        }
    },
    computed: {
        lastUpdate() {
            return utils.formatRelativeTime(this.motm?.votesUpdatedAt);
        },
        votingOpen() {
            return this.motm?.isFinal === false;
        },
        discordVoteLink() {
            return process.env.VUE_APP_MOTM_DISCORD_LINK;
        }
    }
}
</script>

<style scoped>
.box {
    position: relative;
}

.motm-badge {
    position: absolute;
    top: -12px;
    left: var(--spacing-lg);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: var(--fs-sm);
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 999px;
    white-space: nowrap;
}

.motm-badge--live {
    background: var(--error);
    color: var(--text-primary);
    box-shadow: var(--shadow-md);
}

.motm-badge--closed {
    background: var(--secondary-bg);
    color: var(--text-secondary);
    border: 1px solid var(--card-border);
}

.motm-badge-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--text-primary);
    animation: motm-pulse 1.5s ease-in-out infinite;
}

@keyframes motm-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
    }

    70% {
        box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
}

.motm-muted {
    color: var(--text-secondary);
}

.motm-title {
    display: block;
    margin-bottom: var(--spacing-md);
}

.motm-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.motm-row {
    position: relative;
    height: 32px;
    border-radius: var(--radius-md);
    background: var(--secondary-bg);
    overflow: hidden;
}

.motm-row--first {
    height: 32px;
}

/* Bewusst dieselbe Akzentfarbe wie der Rest der App (var(--accent-primary), siehe .modern-btn in
   custom.css) statt eines eigenen Petrol/Tuerkis-Tons, der sonst nirgends vorkam. Flache Flaeche
   statt Verlauf, damit der Balken trotz gleicher Farbe nicht wie ein weiterer Button wirkt. */
.motm-fill {
    position: absolute;
    inset: 0;
    background: var(--accent-primary);
}

.motm-content {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    padding: 0 var(--spacing-sm) 0 var(--spacing-xs);
}

.motm-rank {
    flex-shrink: 0;
    font-weight: 700;
    width: 1.4em;
    text-align: center;
}

.motm-name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
}

.motm-votes {
    flex-shrink: 0;
    font-size: var(--fs-sm);
    opacity: 0.85;
    white-space: nowrap;
}

.motm-pct {
    flex-shrink: 0;
    min-width: 3em;
    text-align: right;
}
</style>
